import type { AdPlatform } from "./resolveClickUrl.js";

/**
 * 광고 클릭 URL 분기에 쓸 플랫폼을 결정한다 (순수 — DOM/Capacitor 비의존, 문자열만 받음).
 *
 * - 네이티브 앱(Capacitor가 "ios"/"android" 반환)이면 그대로 사용한다.
 * - 웹("web" 등 네이티브 외 값)이면 userAgent로 모바일 OS를 감지해 해당 스토어로 보낸다:
 *   모바일 브라우저는 자신의 OS 앱스토어로, 데스크톱 웹은 "web"(기본 clickUrl = Play로 폴백).
 *   → "웹은 기본 Android(Play), 단 모바일 웹이면 그 OS 스토어"라는 요구를 충족.
 *
 * 한계: iPadOS 13+는 userAgent를 "Macintosh"로 보고할 수 있어 데스크톱("web")으로 분류된다
 * (기본 clickUrl=Play로 폴백). 정밀 iPad 감지가 필요하면 호출부에서 touch 지원 여부를 추가 판정한다.
 */
export function resolveAdPlatform(nativePlatform: string, userAgent: string): AdPlatform {
  if (nativePlatform === "ios" || nativePlatform === "android") return nativePlatform;
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "ios";
  if (/Android/i.test(userAgent)) return "android";
  return "web";
}
